import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  ViewChild,
  AfterViewInit,
  ElementRef,
  HostListener,
} from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormArray,
  FormControl,
} from '@angular/forms';
import { slideInDownAnimation } from 'src/app/app.animation';
import {
  ErrorParseService,
  IEventSponsorship,
  PermissionsService,
  LGEDataService,
  IExternalData,
} from 'src/commons';
import { Store } from '@ngrx/store';
import { catchError, map, Observable, of, skipWhile, Subscription } from 'rxjs';
import * as fromEventSponsorship from './state/event-sponsorship.selectors';
import * as EventSponsorshipAction from './state/event-sponsorship.actions';
import * as fromAuth from 'src/screens/login/state/login.selectors';
import * as lgeApp from 'src/app/state/app.actions';
import * as appConfig from 'src/app/app.constant';
import { SignaturePad } from 'angular2-signaturepad';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import * as _ from 'lodash';
import * as moment from 'moment';
import { DecimalPipe } from '@angular/common';
import {
  Router,
  ActivatedRoute,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import saveAs from 'file-saver';
import { PreviousRouteService } from 'src/commons/services/previousRoute.service';
import { AngularMaterialService } from 'src/commons/utilities/angular.material.service';
import { LoginRedirect } from '../login/state/login.actions';
declare let LGEKUFX;

@Component({
  selector: 'event-sponsorship-screen',
  templateUrl: 'event-sponsorship.component.html',
  styleUrls: ['event-sponsorship.scss'],
  animations: [slideInDownAnimation],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EventSponsorshipScreenComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  @Input() private pending$: Observable<boolean>;
  private pendingSubscription: Subscription;
  private pending: boolean = true;
  @Input() private error$: Observable<string | null>;
  private errorSubscription: Subscription;
  private error: string | null;
  @Input() private stateData$: Observable<IEventSponsorship | null>;
  private stateDataSubscription: Subscription;
  private stateData: IEventSponsorship | null;
  @Input() private profileData$: Observable<IExternalData | null>;
  private profileDataSubscription: Subscription;
  private profileData: IExternalData | null;
  esForm: FormGroup;
  serviceAreas = ['LG&E Service Area', 'KU Service Area', 'ODP Service Area'];
  states = appConfig.SHARE_ARRAYS.states;
  fundSources = [
    'Government',
    'United Way',
    'Fund for the Arts',
    'Corporate Donor',
    'Community Foundation',
    'Private Foundation',
    'National Organization',
    'None of These',
  ];
  catReqs = [
    'Arts',
    'Diversity',
    'Economic Development',
    'Education',
    'Environment',
    'Health and Human Services',
    'Other',
  ];
  hasOtherCatFund: boolean = false;
  hasOtherCatReq: boolean = false;
  isReadOnly: boolean = false;
  isShowLeaveDialog: boolean = false;
  formId;
  formData;
  isShowSaveAsDraft = false;
  isShowSaveButton = false;
  isShowAwardedAmount = false;
  isAwardedAmount = false;
  isAwardedAmountEditable = true;
  isTaxExemptEditable = false;

  numPipe = new DecimalPipe('en-Us');

  twoDecMask = createNumberMask({
    prefix: '',
    suffix: '',
    includeThousandsSeparator: true,
    thousandsSeparatorSymbol: '',
    allowDecimal: true,
    decimalSymbol: '.',
    decimalLimit: 2,
    integerLimit: null,
    requireDecimal: false,
    allowNegative: false,
    allowLeadingZeroes: true,
  });

  oneDecMask = createNumberMask({
    prefix: '',
    suffix: '',
    includeThousandsSeparator: true,
    thousandsSeparatorSymbol: '',
    allowDecimal: true,
    decimalSymbol: '.',
    decimalLimit: 1,
    integerLimit: null,
    requireDecimal: false,
    allowNegative: false,
    allowLeadingZeroes: true,
  });
  @ViewChild(SignaturePad) signaturePad: SignaturePad;
  signaturePadOptions: Object = {
    dotSize: 0.6,
    minWidth: 0.6,
    maxWidth: 1.2,
    canvasWidth: 400,
    canvasHeight: 160,
    throttle: 0,
    backgroundColor: 'rgba(238,238,238,1)',
  };
  isInternal: boolean = false;

  @ViewChild('fileInputW9') fileInputW9: ElementRef;
  @ViewChild('fileInputAdditional') fileInputAdditional: ElementRef;
  fileId: String = '';
  W9AttachDeleted = this.fb.array([]);
  AddAttachDeleted = this.fb.array([]);
  attachId: Number = -1;
  isAccDistEditable: boolean = false;
  isShowAccDist: boolean = false;
  taxExemptList: any;
  // isShowReassignBtn: boolean = false;
  isShowWithdrawBtn: boolean = false;
  isShowApproveBtn: boolean = false;
  isFormExpired: boolean = false;
  companyData: any = [];
  expTypeData: any = [];
  expOrgData: any = [];
  projectData: any = [];
  taskData: any = [];
  isADValid: boolean = false;
  ValidatingRow: number = 0;
  isValidatingRow = true;
  isFilled: boolean = false;

  @HostListener('window:beforeunload', ['$event'])
  handleClose($event) {
    if (this.isShowLeaveDialog) {
      $event.returnValue = 'Message here';
      return false;
    }
    return true;
  }

  constructor(
    private store: Store<fromEventSponsorship.State>,
    private storeAuth: Store<fromAuth.State>,
    private ref: ChangeDetectorRef,
    private fb: FormBuilder,
    private ams: AngularMaterialService,
    private permissionsService: PermissionsService,
    private _dataService: LGEDataService,
    private previousRouteService: PreviousRouteService,
    private router: Router,
    private route: ActivatedRoute,
    private errorParse: ErrorParseService
  ) {
    this.isInternal = this.permissionsService.isInternal();
    this.selectState();
    if (this.hasRole('ADMIN')) {
      this.taxExemptList = appConfig.SHARE_ARRAYS.taxExemptList;
    }
    this.createForms();
  }

  ngOnInit() {
    this.startSubscriptions();
    window.addEventListener('beforeunload', function () {
      return 'Dialog Text Here';
    });
  }

  ngAfterViewInit(): void {
    this.signaturePad.clear();
    this.route.params.subscribe((response) => {
      this.formId = parseInt(response['id']);
      if (this.formId) {
        this.checkFormExpired().subscribe({
          next: (result) => {
            new EventSponsorshipAction.LoadEventSponsorshipState(this.formId);
          },
        });
        this.store.dispatch(
          new EventSponsorshipAction.LoadEventSponsorshipState(this.formId)
        );
      } else {
        setTimeout(() => {
          this.AutopopulateInfo();
          this.checkFormExpired().subscribe({
            next: (result) => {
              if (result === 'Expired' && !this.isInternal) {
                this.ams.showAlert(
                  'Expired',
                  'Event Sponsorship Application has been expired!'
                );
                this.ref.markForCheck();
              }
            },
          });
          this.esForm
            .get(['AuthorizedRep', 'date'])
            .setValue(moment().format('MM/DD/YYYY'));
          this.isShowLeaveDialog = !this.isInternal; // internal can't submit, so no need leave dialog
          this.isShowSaveAsDraft = !this.isInternal || this.hasRole('DEV');
          this.ams.closeDialog();
          this.ref.markForCheck();
        });
      }
    });
  }

  hasRole(role: string) {
    return this.permissionsService.hasRoles(role);
  }

  getTaxExemptStatus(value) {
    if (value === '') return 'Other';
    else if (isNaN(value) || +value === 0) {
      return value;
    } else {
      return `501(c)(${+value})`;
    }
  }

  canDeactivate(
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot
  ): boolean | Observable<boolean> | Promise<boolean> {
    return of(true);
    // return Observable.fromPromise(this.sessionCheck())
    //   .exhaustMap(result => {
    //     if (result)
    //       return Observable.fromPromise(this.confirmDialog());
    //     else
    //       return Observable.of(true);
    //   })
  }

  confirmDialog(): Promise<boolean> {
    return new Promise((resolve) => {
      if (this.isShowLeaveDialog && this.esForm.dirty) {
        this.ams.showConfirm(
          'Alert!',
          ' Are you sure you want to navigate away from this page? If you proceed, ALL of your changes will be lost. Press Yes to continue, or Cancel to stay on the current page.'
        );
        this.ams.confirm
          .afterClosed()
          .subscribe((ans) => resolve(ans === 'yes'));
      } else {
        resolve(true);
      }
    });
  }

  // sessionCheck(): Promise<boolean> {
  //   return new Promise(resolve => {
  //     this.authService.validateSession(this.permissionsService.getCurrentSession())
  //       .then((result) => {
  //         if (result)
  //           resolve(true)
  //         else
  //           resolve(false)
  //       })
  //       .catch(error => resolve(false))
  //   })
  // }

  drawComplete() {
    let base64Raw = this.signaturePad.toDataURL('base64').toString();
    this.esForm.get(['AuthorizedRep', 'signature']).setValue(base64Raw);
  }

  drawStart() {}

  drawClear() {
    this.esForm.get(['AuthorizedRep', 'signature']).setValue('');
    this.esForm.get(['AuthorizedRep', 'signature']).updateValueAndValidity();
    this.signaturePad.clear();
  }

  checkFormExpired(): Observable<any> {
    if (
      this.hasRole(
        'ADMIN|CITAPPROVER|CITREVIEWER|FOUNDATIONAPPROVER|FOUNDATIONREVIEWER'
      )
    ) {
      this.isFormExpired = false;
      return of('Open');
    } else {
      return this._dataService.GetActiveForm().pipe(
        map((data) => {
          this.isFormExpired = data.find((item) => item === 'ES') === undefined;
          this.isReadOnly = this.isReadOnly
            ? this.isReadOnly
            : this.isFormExpired;
          this.ref.markForCheck();
          if (this.isFormExpired) {
            this.signaturePad.off();
            this.isShowLeaveDialog = false;
            return of('Expired');
          } else {
            return of('Open');
          }
        }),
        catchError((error) => {
          this.ams.showAlert('Error!', 'Failed checking form expiration!');
          this.ref.markForCheck();
          return of('Error');
        })
      );
      // this.ref.markForCheck();
    }
  }

  getAccountingDistributionData() {
    const accDistParaArray = ['COMPANY', 'EXP_TYPE', 'EXP_ORG'];
    accDistParaArray.forEach((para) =>
      this._dataService.AccDistInfo_GetActiveByName([para, 'CI']).subscribe({
        next: (data) => {
          if (data) {
            switch (para) {
              case 'COMPANY':
                for (let i = 0; i < 2; i++) {
                  this.companyData.push(data);
                }
                this.ref.markForCheck();
                break;
              case 'EXP_TYPE':
                for (let i = 0; i < 2; i++) {
                  this.expTypeData.push(data);
                }
                this.ref.markForCheck();
                break;
              case 'EXP_ORG':
                for (let i = 0; i < 2; i++) {
                  this.expOrgData.push(data);
                }
                this.ref.markForCheck();
                break;
            }
          }
        },
        error: (error) => {
          this.ams.showAlert(
            'Error!',
            `Please contact contributions@lge-ku.com with questions. \n Stack trace: ${error.message}`
          );
          this.ref.markForCheck();
        },
      })
    );
  }

  getProjectTaskData() {
    this._dataService
      .ProjectTaskInfo_GetActiveByName(['PROJ_TASK_PLUS', 'CI'])
      .subscribe({
        next: (data) => {
          if (data) {
            for (let i = 0; i < 2; i++) {
              this.projectData.push(_.uniqBy(data, 'project'));
              this.taskData.push(_.uniqBy(data, 'task'));
            }
            this.ref.markForCheck();
          }
        },
        error: (error) => {
          this.ams.showAlert(
            'Error!',
            `Please contact contributions@lge-ku.com with questions. \n Stack trace: ${error.message}`
          );
          this.ref.markForCheck();
        },
      });
  }

  // Select state
  selectState(): void {
    if (!this.isInternal) {
      this.profileData$ = this.storeAuth
        .select(fromAuth.getExternalProfile)
        .pipe(
          skipWhile(
            (stateData) => stateData === undefined || stateData === null
          )
        );
    }
    this.pending$ = this.store.select(
      fromEventSponsorship.getEventSponsorshipScreenPending
    );
    this.stateData$ = this.store
      .select(fromEventSponsorship.getEventSponsorshipState)
      .pipe(
        skipWhile((stateData) => stateData === undefined || stateData === null)
      );
    this.error$ = this.store
      .select(fromEventSponsorship.getEventSponsorshipScreenError)
      .pipe(
        skipWhile(
          (error) => error === undefined || error === null || error === ''
        )
      );
  }

  displayLoader(pending: boolean): void {
    if (pending) {
      setTimeout(() => {
        this.ams.showLoader('Loading');
        this.ref.markForCheck();
      });
    } else {
      this.ams.closeDialog().then(() => {
        if (
          this.error !== null &&
          this.error !== undefined &&
          this.error !== ''
        ) {
          this.displayError(this.error);
        }
      });
    }
  }

  displayError(error: any): void {
    let errorMessage;
    if (this.errorParse.foundKeyWord(error, 'CORPCOMMONWS')) {
      errorMessage = this.errorParse.translateCCError(error);
    } else {
      errorMessage = error instanceof Object ? error.message : error;
    }
    this.ams.showAlert('Loading Error', errorMessage);
    this.ams.alert.afterClosed().subscribe((result) => {
      this.store.dispatch(
        new EventSponsorshipAction.EventSponsorshipScreenErrorReset()
      );
    });
  }

  // Create reactive forms
  createForms(): void {
    this.esForm = this.fb.group({
      OrgContactInfo: this.fb.group({
        orgContactInfoId: [null],
        firstName: ['', Validators.required],
        lastName: ['', Validators.required],
        phone: [
          '',
          [
            Validators.required,
            Validators.pattern(new RegExp(/^\d{3}-\d{3}-\d{4}/)),
          ],
        ],
        email: [
          '',
          [
            Validators.required,
            Validators.maxLength(254),
            Validators.pattern(
              new RegExp(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/)
            ),
          ],
        ],
      }),

      OrgInfo: this.fb.group({
        orgInfoId: [null],
        name: ['', [Validators.required]],
        payToOption: ['No'],
        payTo: ['', Validators.maxLength(80)],
        EIN: [
          '',
          [
            Validators.required,
            Validators.maxLength(10),
            Validators.pattern(new RegExp(/^\d{2}-\d{7}/)),
          ],
        ],
        address1: ['', [Validators.required, Validators.maxLength(35)]],
        address2: ['', [Validators.maxLength(35)]],
        city: ['', [Validators.required, Validators.maxLength(50)]],
        state: ['', Validators.required],
        zipCode: [
          '',
          [
            Validators.required,
            Validators.pattern(new RegExp(/^\d{5}(-?\d{4})?$/)),
          ],
        ],
        webAddress: [''],
        orgDesc: ['', [Validators.required]],
        president: ['', Validators.required],
        email: [
          '',
          [
            Validators.required,
            Validators.maxLength(254),
            Validators.pattern(
              new RegExp(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/)
            ),
          ],
        ],
        subsection_501: [''],
      }),

      AccDistribution: this.fb.array([
        this.fb.group({
          accDistributionId: [null],
          formId: [null],
          company: [''],
          project: [''],
          task: [''],
          expType: [''],
          expOrg: [''],
          amount: [''],
        }),
        this.fb.group({
          accDistributionId: [null],
          formId: [null],
          company: [''],
          project: [''],
          task: [''],
          expType: [''],
          expOrg: [''],
          amount: [''],
        }),
      ]),

      AuthorizedRep: this.fb.group({
        authRepId: [null],
        name: ['', [Validators.required, Validators.maxLength(50)]],
        date: ['', [Validators.required]],
        signature: [''],
      }),

      W9Attach: this.fb.array([]),
      AddAttach: this.fb.array([]),

      FormLogInfo: this.fb.group({
        formId: [null],
        formLogId: [null],
        effdt: [''],
        action: [''],
        comment: [''],
        empId: [''],
        empName: [''],
        empTypeForLog: [''],
        status: [''],
        title: [''],
      }),

      formId: [null],
      orgContactInfoId: [null],
      orgInfoId: [null],
      authRepId: [null],
      userId: [''],
      serviceArea: [[], Validators.required],
      categoryRequest: ['', Validators.required],
      categoryRequestOther: [''],
      empName: [''],
      isVolunteerProvided: ['No', Validators.required],
      eventName: ['', Validators.required],
      eventLocation: ['', Validators.required],
      eventDate: [''],
      eventCost: ['', Validators.required],
      attendance: ['', Validators.required],
      recognition: ['', Validators.required],
      requestedAmount: ['', Validators.required],
      eventDescr: ['', Validators.required],

      companyList: this.fb.array([
        this.fb.group({
          companyId: [null],
          formId: [null],
          companyName: [''],
          contribution: [''],
        }),
        this.fb.group({
          companyId: [null],
          formId: [null],
          companyName: [''],
          contribution: [''],
        }),
        this.fb.group({
          companyId: [null],
          formId: [null],
          companyName: [''],
          contribution: [''],
        }),
        this.fb.group({
          companyId: [null],
          formId: [null],
          companyName: [''],
          contribution: [''],
        }),
        this.fb.group({
          companyId: [null],
          formId: [null],
          companyName: [''],
          contribution: [''],
        }),
      ]),

      payment: ['CHECK', Validators.required],
      amount: [''],
      statusId: [null],
      statusDescr: [''],
      statusDescrAdmin: [''],
      requestName: [''],
      requestNo: [''],
      submittedDate: [new Date()],
      lastUpdatedDate: [''],
      lastUpdatedBy: [''],
      deleteIt: [''],
    });

    this.esForm.get(['OrgInfo', 'name']).valueChanges.subscribe((value) => {
      let nameLength = value.length;
      if (nameLength > 80) {
        this.esForm.get(['OrgInfo', 'payToOption']).setValue('yes');
        if (this.esForm.get(['OrgInfo', 'payTo']).value.length === 0) {
          this.esForm
            .get(['OrgInfo', 'payTo'])
            .setValue(value.substring(0, 80));
        }
        this.esForm.get(['OrgInfo', 'name']).setValue(name);
      }
    });

    this.esForm
      .get(['OrgInfo', 'payToOption'])
      .valueChanges.subscribe((value) => {
        let isPayTo = value === null ? false : value === 'Yes';
        if (isPayTo) {
          this.esForm
            .get(['OrgInfo', 'payTo'])
            .setValidators([Validators.required]);
          this.esForm.get(['OrgInfo', 'payTo']).updateValueAndValidity();
        } else {
          this.esForm.get(['OrgInfo', 'payTo']).setValue('');
          this.esForm.get(['OrgInfo', 'payTo']).setValidators([]);
          this.esForm.get(['OrgInfo', 'payTo']).updateValueAndValidity();
        }
      });

    this.esForm.get('categoryRequest').valueChanges.subscribe((value) => {
      this.hasOtherCatReq = value === 'Other';
      if (!this.hasOtherCatReq) {
        this.esForm.get('categoryRequestOther').setValue('');
        this.esForm.get('categoryRequestOther').setValidators([]);
        this.esForm.get('categoryRequestOther').updateValueAndValidity();
      } else {
        this.esForm
          .get('categoryRequestOther')
          .setValidators([Validators.required]);
        this.esForm.get('categoryRequestOther').updateValueAndValidity();
      }
    });

    this.esForm.controls['AccDistribution'].valueChanges.subscribe((value) => {
      let adArray = this.esForm.get('AccDistribution') as FormArray;
      this.isAwardedAmountEditable = !adArray.controls.some((ad) => {
        return +ad.value.amount !== 0;
      });
      const validateObj = value[this.ValidatingRow];
      if (validateObj !== undefined) {
        if (
          validateObj.company !== '' &&
          validateObj.project !== '' &&
          validateObj.task !== '' &&
          validateObj.expType !== '' &&
          validateObj.expOrg !== '' &&
          this.isValidatingRow
        ) {
          this.isValidatingRow = false;
          this.Validate_Project_Task(validateObj);
        }
        this.callValidateAPI();
      }
    });
    if (this.isInternal) {
      this.getAccountingDistributionData();
      this.getProjectTaskData();
    }
  }

  createAttachment(fileId, base64, name, size, type): FormGroup {
    return this.fb.group({
      attachId: [-1],
      formId: [-1],
      fileId: [fileId],
      attachString: [base64],
      attachName: [name],
      attachSize: [size],
      attachType: [type],
      deleteIt: [0],
    });
  }

  DownloadAllAttachFile() {
    if (this.formId) {
      const arrayAddAttach = this.esForm.get('AddAttach') as FormArray;
      arrayAddAttach.controls.forEach((item) => {
        this.DownloadAttachFile('AddAttach', item.value.attachName);
      });
    }
  }

  DownloadAttachFile(attachType: string, fileName) {
    const attachments = this.esForm.get(attachType) as FormArray;
    const file = attachments.controls.find((item) => {
      return item.value.attachName === fileName;
    });
    this.ams.showLoader('Downloading...');
    if (file.value.attachId !== -1) {
      this._dataService
        .DownloadAttachmentFileById(file.value.attachId, 'ES')
        .subscribe((response) => {
          saveAs(response, `${file.value.attachName}`);
          this.ams.closeDialog();
        });
    } else {
      this.ams.showAlert(
        'Failed to download',
        `You must saved change(s) first to download ${fileName} file`
      );
    }
  }

  handleReaderForm(attachType: string, e) {
    let base64 = [];
    base64.push(btoa(e.target.result));
    this.esForm.get([attachType, '0', 'attachString']).setValue(base64[0]);
  }

  uploadToFileService(file, type): Promise<any> {
    return new Promise((resolve) => {
      this.ams.showLoader('Validating file...');
      let corpCommonSessionInfo =
        this.permissionsService.getCorpCommonSessionInfo();
      var getCorpCommonSessionInfo = function (callback) {
        callback(corpCommonSessionInfo);
      };
      LGEKUFX.registerCorpCommonSessionHandler(getCorpCommonSessionInfo);
      var upload = LGEKUFX.uploadFileSync(
        file,
        (error) => {
          this.ams.closeDialog();
          if (error.message.includes('Request failed to authenticate')) {
            this.ams.showAlert(
              'Session Timeout',
              'Your session has been expired due to inactivity.  Please click OK to log in again.'
            );
            this.ams.alert.afterClosed().subscribe(() => {
              this.storeAuth.dispatch(new LoginRedirect());
            });
            setTimeout(() => {
              this.storeAuth.dispatch(new LoginRedirect());
            }, 10000);
          } else {
            this.ams.showAlert(
              'Error',
              `Failed to validate ${
                file.name
              } file. Please try other file or try again later. \nStack Trace: ${JSON.stringify(
                error
              )}`
            );
          }
          resolve('Invalid');
        },
        (bytesUploaded, bytesTotal) => {},
        () => {
          const fileId = upload.getFileId();
          let tempAttach: any = {};

          tempAttach = this.createAttachment(fileId, '', '', '0', type);
          tempAttach.value.formId = -5;

          this._dataService
            .ImportFileFromFileService(tempAttach.value)
            .subscribe({
              next: (data) => {
                this.attachId = data;
                this.ams.closeDialog();
                this.ref.markForCheck();
                resolve('Valid');
              },
              error: (error) => {
                this.ams.closeDialog();
                this.ref.markForCheck();
                this.ams.showAlert(
                  'Error',
                  `Failed to validate ${
                    file.name
                  } file. Please try other file or try again later. \nStack Trace: ${JSON.stringify(
                    error
                  )}`
                );
                resolve('Invalid');
              },
            });
        }
      );
    });
  }

  removeAttach(type) {
    let AttachArray = this.esForm.get(type) as FormArray;
    let length = AttachArray.controls.length;
    for (let i = 0; i < length; i++) {
      const item = AttachArray.controls[i];
      AttachArray.removeAt(0);
      if (item.value.attachId !== -1) {
        item.value.deleteIt = 1;
        switch (type) {
          case 'W9Attach':
            this.W9AttachDeleted.push(item as FormControl);
            break;
          case 'AddAttach':
            this.AddAttachDeleted.push(item as FormControl);
            break;
        }
      }
    }
    // AttachArray.controls.forEach((item, index) => {
    //   AttachArray.removeAt(index);
    //   if (item.value.attachId !== -1) {
    //     item.value.deleteIt = 1;
    //     switch (type) {
    //       case 'W9Attach':
    //         this.W9AttachDeleted.push(item as FormControl);
    //         break;
    //       case 'AddAttach':
    //         this.AddAttachDeleted.push(item as FormControl);
    //         break;
    //     }
    //   }
    // });
  }

  onAttachFileChange(event, type: string) {
    if (event.target.files.length > 0) {
      if (event.target.files[0].type !== 'application/pdf') {
        this.clearInput(type);
        this.ams.showAlert(
          '',
          'Only PDF file is allowed, please choose another file'
        );
      } else {
        if (event.target.files[0].size > 10485760) {
          // max 10MB - 10485760
          this.clearInput(type);
          this.ams.showAlert(
            '',
            'Attachment size exceeds the allowable limit, please choose another file'
          );
        } else {
          this.fileId = '';
          if (this.isInternal) {
            if (this.esForm.get([type, '0']) === null) {
              (<FormArray>this.esForm.get(type)).push(
                this.createAttachment(
                  'NA',
                  '',
                  event.target.files[0].name,
                  event.target.files[0].size.toString(),
                  type
                )
              );
            } else {
              this.removeAttach(type);
              (<FormArray>this.esForm.get(type)).push(
                this.createAttachment(
                  'NA',
                  '',
                  event.target.files[0].name,
                  event.target.files[0].size.toString(),
                  type
                )
              );
            }
            const reader = new FileReader();
            reader.onload = this.handleReaderForm.bind(this, type);
            reader.readAsBinaryString(event.target.files[0]);
          } else {
            if (this.esForm.get(type).value.length > 1) this.removeAttach(type);
            let tempW9 = this.createAttachment(
              'NA',
              '',
              event.target.files[0].name,
              event.target.files[0].size.toString(),
              type
            );
            this.uploadToFileService(event.target.files[0], type).then(
              (result) => {
                if (result === 'Valid') {
                  tempW9.value.attachId = this.attachId;
                  if (this.esForm.get([type, '0']) === null) {
                    (<FormArray>this.esForm.get(type)).push(tempW9);
                  } else {
                    this.removeAttach(type);
                    (<FormArray>this.esForm.get(type)).push(tempW9);
                  }
                  this.attachId = -1;
                  this.ref.markForCheck();
                }
              }
            );
          }
        }
      }
    }
  }

  resetFileInput(type) {
    this.removeAttach(type);
    switch (type) {
      case 'W9Attach':
        this.fileInputW9.nativeElement.value = '';
        break;
      case 'AddAttach':
        this.fileInputAdditional.nativeElement.value = '';
        break;
    }
  }

  onAddAttachFileChange(event) {
    let fileList = [];
    fileList = Array.from(event.target.files);
    if (fileList.length > 0) {
      if (fileList.length < 10) {
        let isPDFIndex = fileList.findIndex(
          (item) => item.type !== 'application/pdf'
        );
        if (isPDFIndex <= -1) {
          const newLength = fileList.length;
          const uploadedLength = this.esForm.value.AddAttach.length;
          if (newLength + uploadedLength <= 10) {
            let uploadFileSize: number = 0;
            let currentFileSize: number = 0;
            let totalFileSize = 0;
            for (let i = 0; i < newLength; i++) {
              uploadFileSize += parseInt(fileList[i].size);
            }
            if (uploadedLength > 0) {
              for (let i = 0; i < uploadedLength; i++) {
                currentFileSize += parseInt(
                  this.esForm.get(['AddAttach', i.toString(), 'attachSize'])
                    .value
                );
              }
            }
            totalFileSize = uploadFileSize + currentFileSize;
            if (totalFileSize < 10485760) {
              let current = fileList.map(function (item) {
                return item.name;
              });
              if (this.esForm.value.AddAttach.length > 0) {
                let upload = this.esForm.value.AddAttach.map(function (item) {
                  return item.attachName;
                });
                current = [...current, ...upload];
              }
              let isDuplicate = current.some(function (item, idx) {
                return current.indexOf(item) != idx;
              });

              if (!isDuplicate) {
                let AddArray = this.esForm.get('AddAttach') as FormArray;
                for (let i = 0; i < fileList.length; i++) {
                  if (this.isInternal) {
                    let tempAddAttach = this.createAttachment(
                      'NA',
                      '',
                      fileList[i].name,
                      fileList[i].size.toString(),
                      'AddAttach'
                    );
                    const reader: any = new FileReader();
                    const self = this;
                    reader.onload = function (e) {
                      let i = AddArray.length;
                      let base64 = [];
                      base64.push(btoa(e.target.result));
                      tempAddAttach.value.attachString = base64[0];
                      AddArray.push(tempAddAttach);
                      self.ref.markForCheck();
                    };
                    reader.readAsBinaryString(fileList[i]);
                    this.ref.markForCheck();
                  } else {
                    this.uploadToFileService(fileList[i], 'AddAttach').then(
                      (result) => {
                        if (result === 'Valid') {
                          let tempAddAttach = this.createAttachment(
                            'NA',
                            '',
                            fileList[i].name,
                            fileList[i].size.toString(),
                            'AddAttach'
                          );
                          tempAddAttach.value.attachId = this.attachId;
                          this.attachId = -1;
                          AddArray.push(tempAddAttach);
                          this.ref.markForCheck();
                        }
                      }
                    );
                  }
                  this.fileInputAdditional.nativeElement.value = '';
                }
              } else {
                this.ams.showAlert(
                  '',
                  'Some of the files are already attached'
                );
              }
            } else {
              this.ams.showAlert(
                '',
                'Attachment size exceeds the allowable limit, please remove some files'
              );
            }
          } else {
            this.fileInputAdditional.nativeElement.value = '';
            this.ams.showAlert(
              '',
              'Number of Attachments exceeds the allowable limit(10 files), please remove some files'
            );
          }
        } else {
          this.fileInputAdditional.nativeElement.value = '';
          this.ams.showAlert(
            '',
            'Only PDF files are allowed, please choose another file'
          );
        }
      } else {
        this.fileInputAdditional.nativeElement.value = '';
        this.ams.showAlert(
          '',
          'Number of Attachments exceeds the allowable limit(10 files), please remove some files'
        );
      }
    }
    this.ref.markForCheck();
  }

  clearInput(type: String) {
    switch (type) {
      case 'W9Attach':
        this.fileInputW9.nativeElement.value = '';
        break;
      case 'AddAttach':
        this.fileInputAdditional.nativeElement.value = '';
        break;
    }
  }

  removeAddFile(fileName) {
    let arrayAddAttach = this.esForm.get('AddAttach') as FormArray;
    arrayAddAttach.controls.forEach((item, index) => {
      if (item.value.attachName === fileName) {
        arrayAddAttach.removeAt(index);
        if (item.value.attachId !== -1) {
          item.value.deleteIt = 1;
          this.AddAttachDeleted.push(item as FormControl);
        }
      }
    });
  }

  onAmountChange(value, index: number) {
    // let tempAmount = ""// =
    // if (value !== '' && value.includes('.')) {
    //   const dec = value.split('.')[1];
    //   if (dec == "00" || dec == "" || dec == "0") {
    //     tempAmount = value.split('.')[0];
    //   } else {
    //     tempAmount = this.numPipe.transform(+parseFloat(value).toFixed(2), '1.2-2').replace(/,/g, '');
    //   }
    // }
    // else {
    //   tempAmount = value;
    // }
    // this.esForm.get(['AccDistribution', index.toString(), 'amount']).setValue(tempAmount);
  }

  calculateTotalAmount() {
    const projectDetails = this.esForm.controls['AccDistribution'].value;
    let newTotalAmount = 0;
    projectDetails.forEach((project) => {
      let amount = project.amount;
      let newAmount;
      if (amount == undefined || amount == null || amount == '') {
        newAmount = 0;
      } else {
        newAmount = parseFloat(amount);
      }
      newTotalAmount += newAmount; //+(parseFloat(project.amount) || 0).toFixed(2);+
    });
    let temp = this.numPipe
      .transform(newTotalAmount.toFixed(2), '1.2-2')
      .replace(/,/g, '');
    temp = temp.split('.')[1] === '00' ? temp.split('.')[0] : temp;
    this.isAwardedAmountEditable = +temp === 0;
    this.esForm.get('amount').setValue(temp);
  }

  populateCompany(value, index) {
    if (this.companyData[0] !== undefined) {
      if (index === 0) {
        const selectedComp = this.companyData[0].filter(
          (x) => x.code === value
        );
        let i = 1;
        for (i; i < 2; i++) {
          this.companyData[i] = selectedComp;
          this.esForm
            .get(['AccDistribution', i.toString(), 'company'])
            .setValue('');
        }
      } else {
        if (this.esForm.controls['AccDistribution'].value[0].company === '') {
          this.ams.showAlert('Error!', 'Please select company for first row!');
          this.esForm
            .get(['AccDistribution', index.toString(), 'company'])
            .setValue('');
          return;
        }
      }
      this.ref.markForCheck();
    } else {
      this.populateCompany(value, index);
    }
  }

  onAccDistSelect(value, index: number, selectedData: string): void {
    if (value) {
      this.ValidatingRow = index;
      this.isValidatingRow = true;
      switch (selectedData) {
        case 'company':
          this.populateCompany(value, index);
          this.esForm
            .get(['AccDistribution', index.toString(), 'project'])
            .setValue('');
          this.esForm
            .get(['AccDistribution', index.toString(), 'task'])
            .setValue('');
          break;

        case 'project':
          this.esForm
            .get(['AccDistribution', index.toString(), 'task'])
            .setValue('');
          break;
        case 'task':
          this.esForm
            .get(['AccDistribution', index.toString(), 'expType'])
            .setValue('');
          this.esForm
            .get(['AccDistribution', index.toString(), 'expOrg'])
            .setValue('');
          break;

        case 'expType':
          this.esForm
            .get(['AccDistribution', index.toString(), 'expOrg'])
            .setValue('');
          break;
      }
    }
  }

  callValidateAPI() {
    for (let i = 0; i < 2; i++) {
      // 2 to this.accDistData.length
      const validateObj = this.esForm.controls['AccDistribution'].value[i];
      if (
        validateObj.company !== '' &&
        validateObj.project !== '' &&
        validateObj.task !== '' &&
        validateObj.expType !== '' &&
        validateObj.expOrg !== '' &&
        validateObj.amount !== ''
      ) {
        this.isFilled = true;
      } else if (
        validateObj.company === '' &&
        validateObj.project === '' &&
        validateObj.task === '' &&
        validateObj.expType === '' &&
        validateObj.expOrg === '' &&
        validateObj.amount === ''
      ) {
        this.isFilled = true;
      } else {
        this.isFilled = false;
        break;
      }
    }
  }

  Validate_Project_Task(data) {
    let validateObj: any = {
      project: data.project,
      task: data.task,
      expenditureType: data.expType,
      expenditureOrg: data.expOrg,
      company: data.company,
    };
    let jsonData = JSON.stringify(validateObj);
    this.ams.showLoader('Validating...');
    if (this.hasRole('CITAPPROVER') || this.hasRole('ADMIN')) {
      this._dataService.Validate_Project_Task(jsonData).subscribe({
        next: (data) => {
          this.ams.closeDialog();
          if (data) {
            const validateResult = JSON.parse(data);
            this.isADValid =
              validateResult.statusCode === 'VALID' ? true : false;
            if (!this.isADValid) {
              this.ams.showAlert(
                validateResult.statusCode,
                validateResult.statusMessage
              );
            }
            this.ref.markForCheck();
          }
        },
        error: (error) => {
          this.ams.showAlert(
            'Error!',
            `Please contact contributions@lge-ku.com with questions. \n Stack trace: ${error.message}`
          );
          this.ams.closeDialog();
          this.ref.markForCheck();
        },
      });
    } else {
      this.ams.closeDialog();
      this.isADValid = true;
      this.ref.markForCheck();
    }
  }

  // Opens sidenav if on mobile
  public openSidenav(): void {
    this.store.dispatch(new lgeApp.OpenSidenav());
  }

  AutopopulateInfo() {
    this.esForm
      .get(['OrgInfo', 'name'])
      .setValue(this.profileData.orgInfoExt.name);
    this.esForm
      .get(['OrgInfo', 'EIN'])
      .setValue(this.profileData.orgInfoExt.EIN);
    this.esForm
      .get(['OrgInfo', 'address1'])
      .setValue(this.profileData.orgInfoExt.address1);
    this.esForm
      .get(['OrgInfo', 'address2'])
      .setValue(this.profileData.orgInfoExt.address2);
    this.esForm
      .get(['OrgInfo', 'city'])
      .setValue(this.profileData.orgInfoExt.city);
    this.esForm
      .get(['OrgInfo', 'state'])
      .setValue(this.profileData.orgInfoExt.state);
    this.esForm
      .get(['OrgInfo', 'zipCode'])
      .setValue(this.profileData.orgInfoExt.zipCode);
    this.esForm
      .get(['OrgInfo', 'subsection_501'])
      .setValue(this.profileData.orgInfoExt.subsection_501);
    this.esForm
      .get(['OrgContactInfo', 'firstName'])
      .setValue(this.profileData.orgContactInfoExt.firstName);
    this.esForm
      .get(['OrgContactInfo', 'lastName'])
      .setValue(this.profileData.orgContactInfoExt.lastName);
    this.esForm
      .get(['OrgContactInfo', 'phone'])
      .setValue(this.profileData.orgContactInfoExt.phone);
    this.esForm
      .get(['OrgContactInfo', 'email'])
      .setValue(this.profileData.orgContactInfoExt.email);
  }

  //save form as draft
  onSaveAsDraft() {
    // this._dataService.setFormCCName(this.esForm.get('eventName').value);
    // this.ams.showConfirmation('Are you sure you want to save as draft?', 'ES');
    this.ams.showConfirmation(
      `Are you sure you want to save as draft?`,
      'ES',
      this.esForm.get('eventName').value,
      30
    );

    this.ams.confirmation.afterClosed().subscribe((result) => {
      if (result) {
        this.checkFormExpired().subscribe({
          next: (status) => {
            this.ams.closeDialog();
            this.ref.markForCheck();
            this.esForm.get('submittedDate').setValue(new Date());
            this.esForm.value.userId = this.permissionsService.getUserId();
            this.esForm.value.requestName = result.formName;
            this.esForm.value.eventName = result.formName;
            this.esForm.value.statusId = 2;
            this.esForm.value.deleteIt = 'false';
            this.esForm.value.AddAttach.push(...this.AddAttachDeleted.value);
            this.esForm.value.W9Attach.push(...this.W9AttachDeleted.value);

            this.ams.showLoader('Drafting...');
            this._dataService.formESIUD(this.esForm.value).subscribe({
              next: (response) => {
                this.ams.closeDialog();
                this.ref.markForCheck();
                if (response === 'error') {
                  this.ams.showAlert('Error!', 'please try again!');
                } else {
                  this.isShowLeaveDialog = false;
                  if (status === 'Expired') {
                    this.ams.showAlert(
                      'Expired',
                      'The application has been expired !!!'
                    );
                  } else {
                    this.ams.showAlert('Success!', 'Successfully Drafted!');
                  }
                  this.ref.markForCheck();
                  let leaving = setTimeout(() => {
                    this.toHome();
                  }, 5000);
                  this.ams.alert.afterClosed().subscribe(() => {
                    this.toHome();
                    clearTimeout(leaving);
                  });
                }
              },
              error: (error) => {
                this.ams.closeDialog();
                this.ams.showAlert('Error!', error.message);
              },
            });
            this._dataService.setFormCCName('');
          },
        });
      }
    });
  }

  onSubmit() {
    this.esForm
      .get(['AuthorizedRep', 'signature'])
      .setValidators([Validators.required]);
    this.esForm.get(['AuthorizedRep', 'signature']).updateValueAndValidity();
    if (this.esForm.invalid)
      this.ams.showAlert(
        'Alert',
        'Please complete all required field(s) marked with an *'
      );
    else if (this.esForm.value.W9Attach.length === 0) {
      this.ams.showAlert(
        'Alert',
        'Please attach required PDF documents marked with an *'
      );
    } else {
      // this._dataService.setFormCCName(this.esForm.get('eventName').value);
      this.ams.showConfirmation(
        `Are you sure you want to ${
          this.isShowSaveAsDraft ? 'submit' : 'save'
        }?`,
        'ES',
        this.esForm.get('eventName').value,
        30
      );
      this.ams.confirmation.afterClosed().subscribe((result) => {
        if (result && result.formName) {
          this.checkFormExpired().subscribe({
            next: (status) => {
              this.esForm.get('requestName').setValue(result.formName);
              this.esForm.get('eventName').setValue(result.formName);
              this.savingForm(status).subscribe({
                next: (result) => {
                  if (result !== 'error') {
                    this.ams.closeDialog();
                    this.ref.markForCheck();
                    this.isShowLeaveDialog = false;
                    if (status === 'Expired') {
                      this.ams.showAlert(
                        'Expired',
                        'The application has been expired !!!'
                      );
                    } else if (this.isShowSaveAsDraft) {
                      this.ams.showAlert('Success!', 'Successfully submitted!');
                    } else {
                      this.ams.showAlert('Success!', 'Successfully saved!');
                    }
                    this.ref.markForCheck();
                    let leaving = setTimeout(() => {
                      this.toHome();
                    }, 5000);
                    this.ams.alert.afterClosed().subscribe(() => {
                      this.toHome();
                      clearTimeout(leaving);
                    });
                  }
                },
              });
            },
          });
        }
      });
    }
  }

  savingForm(status): Observable<any> {
    this.esForm.value.deleteIt = 'false';
    if (
      this.esForm.value.statusId === 2 ||
      this.esForm.value.statusId === null
    ) {
      this.esForm.get('statusId').setValue(status !== 'Open' ? 1 : 2);
      this.esForm.get('submittedDate').setValue(new Date());
      let userId = this.esForm.value.userId;
      this.esForm.value.userId =
        userId === '' ? this.permissionsService.getUserId() : userId;
    }
    this.esForm.value.deleteIt = 'false';
    this.esForm.value.AddAttach.push(...this.AddAttachDeleted.value);
    this.esForm.value.W9Attach.push(...this.W9AttachDeleted.value);

    this.ams.showLoader(this.isShowSaveAsDraft ? 'Submitting...' : 'Saving...');
    return this._dataService.formESIUD(this.esForm.value).pipe(
      map((response) => {
        this.ams.closeDialog();
        this.ref.markForCheck();
        this._dataService.setFormCCName('');
        return of(response);
      }),
      catchError((error) => {
        this.ams.closeDialog();
        this.ams.showAlert(
          'Error!',
          `Please contact contributions@lge-ku.com with questions. \n Stack trace: ${error.message}`
        );
        this.ref.markForCheck();
        this._dataService.setFormCCName('');
        return of('error');
      })
    );
  }

  // Withdraw or Reject or Reassign
  onWithdrawReject(action) {
    const data: any = {};
    data.formId = this.formData.FormLogInfo.formId;
    data.formLogId = this.formData.FormLogInfo.formLogId;
    data.empId = !this.isInternal
      ? this.formData.userId
      : this.formData.FormLogInfo.empId;
    data.empName = !this.isInternal
      ? 'External Submitter'
      : this.formData.FormLogInfo.empName;
    data.action = action;
    data.orgName = this.formData.OrgInfo.name;
    data.status = this.formData.FormLogInfo.status;
    data.email = '';
    data.userId = this.formData.userId;
    data.empTypeForLog = !this.isInternal
      ? 'External Submitter'
      : this.formData.FormLogInfo.empTypeForLog;
    data.empTitle = !this.isInternal
      ? 'External Submitter'
      : this.formData.FormLogInfo.title;

    this.ams.showApproveReject(
      `Are you sure you want to ${
        action === 'Withdrawn'
          ? 'withdraw'
          : action === 'Rejected'
          ? 'reject'
          : 'reassign to CIT'
      }?`,
      ''
    );
    this.ams.approveReject.afterClosed().subscribe((result) => {
      if (result) {
        data.comment = result.comment;
        this.ams.showLoader(
          ` ${action === 'Withdrawn' ? 'Withdrawing' : 'Rejecting'}...`
        );
        this._dataService.AprroveRejectWithdrawFormES(data).subscribe({
          next: (data) => {
            this.isShowLeaveDialog = false;
            this.ams.closeDialog();
            this.ams.showAlert(
              'Success!',
              `Successfully ${
                action === 'Withdrawn' ? 'withdrawn' : 'Rejecting'
              }!`
            );
            this.ref.markForCheck();
            let leaving = setTimeout(() => {
              this.toHome();
            }, 5000);
            this.ams.alert.afterClosed().subscribe(() => {
              this.toHome();
              clearTimeout(leaving);
            });
          },
          error: (error) => {
            this.ams.closeDialog();
            this.ams.showAlert(
              'Error!',
              `Please contact contributions@lge-ku.com with questions. \n Stack trace: ${error.message}`
            );
            this.ref.markForCheck();
          },
        });
      }
    });
  }

  onApprove() {
    if (this.esForm.invalid)
      this.ams.showAlert(
        'Alert',
        'Please complete all required field(s) marked with an *'
      );
    else if (this.esForm.value.W9Attach.length === 0) {
      this.ams.showAlert(
        'Alert',
        'Pleasen attach required PDF documents marked with an *'
      );
    } else {
      const data: any = {};
      data.formId = this.esForm.value.formId;
      data.formLogId = this.formData.FormLogInfo.formLogId;
      data.empId = this.formData.FormLogInfo.empId;
      data.empName = this.formData.FormLogInfo.empName;
      data.action = 'Approved';
      data.orgName = this.formData.OrgInfo.name;
      data.status = this.formData.FormLogInfo.status;
      data.email = '';
      data.userId = this.formData.userId;
      data.empTypeForLog = this.formData.FormLogInfo.empTypeForLog;
      data.empTitle = this.formData.FormLogInfo.title;

      this.ams.showApproveReject('Are you sure you want to Approve?', '');
      this.ams.approveReject.afterClosed().subscribe((result) => {
        if (result) {
          this.savingForm(data).subscribe({
            next: (submitted) => {
              if (submitted !== 'error') {
                data.comment = result.comment;
                this.ams.showLoader('Approving...');
                this._dataService.AprroveRejectWithdrawFormES(data).subscribe({
                  next: (data) => {
                    this.isShowLeaveDialog = false;
                    this.ams.closeDialog();
                    if (data === 'ALREADYDONE') {
                      this.ams.showAlert(
                        'Error!',
                        'This request has already been approved!'
                      );
                    } else {
                      this.ams.showAlert('Success!', 'Successfully approved!');
                    }
                    this.ref.markForCheck();
                    let leaving = setTimeout(() => {
                      this.toHome();
                    }, 5000);
                    this.ams.alert.afterClosed().subscribe(() => {
                      this.toHome();
                      clearTimeout(leaving);
                    });
                  },
                  error: (error) => {
                    this.ams.closeDialog();
                    this.ams.showAlert(
                      'Error!',
                      `Please contact contributions@lge-ku.com with questions. \n Stack trace: ${error.message}`
                    );
                    this.ref.markForCheck();
                  },
                });
              }
            },
          });
        }
      });
    }
  }

  // cancel form
  onCancel() {
    this.toHome();
  }

  toHome() {
    const previousUrl = this.previousRouteService.getPreviousUrl();
    if (previousUrl?.includes('admin')) {
      this.router.navigate([previousUrl]);
    } else {
      this.router.navigate(['']);
    }
  }

  // Subscribe to state data and mark it for changes
  startSubscriptions(): void {
    this.pendingSubscription = this.pending$.subscribe((data) => {
      this.pending = data;
      this.displayLoader(this.pending);
      this.ref.markForCheck();
    });
    this.errorSubscription = this.error$.subscribe((data) => {
      this.error = data;
      this.ref.markForCheck();
    });

    if (!this.isInternal) {
      this.profileDataSubscription = this.profileData$.subscribe((data) => {
        this.profileData = data;
        this.ref.markForCheck();
      });
    }

    this.stateDataSubscription = this.stateData$.subscribe((data) => {
      this.formData = JSON.parse(JSON.stringify(data));
      if (
        !this.isInternal &&
          this.profileData.externalUser.email.toLowerCase() !==
          this.formData.userId
      ) {
        this.toHome();
      }
      if (
        !this.isInternal &&
        this.isFormExpired &&
        this.formData.statusId === 2
      ) {
        this.ams.showAlert(
          'Expired',
          'Event Sponsorship Application has been expired!'
        );
        this.ref.markForCheck();
      }
      this.formData.serviceArea =
        this.formData.serviceArea === ''
          ? []
          : this.formData.serviceArea.split('|');
      const AddLength = this.formData.AddAttach.length;
      for (let i = 0; i < AddLength; i++) {
        (<FormArray>this.esForm.controls['AddAttach']).push(
          this.createAttachment('NA', '', '', '0', 'AddAttach')
        );
      }
      // init W9Array
      if (this.formData.W9Attach.length > 0) {
        (<FormArray>this.esForm.get('W9Attach')).push(
          this.createAttachment('NA', '', '', '0', 'W9Attach')
        );
      }

      if (this.formData.statusId === 9 || this.formData.statusId === 23) {
        this.esForm.get('amount').setValidators([Validators.required]);
        this.esForm.get('amount').updateValueAndValidity();
      } else if (
        this.formData.statusId !== 3 &&
        this.formData.statusId !== 11
      ) {
        this.isValidatingRow = false;
      }
      this.esForm.setValue(this.formData);

      this.signaturePad.fromDataURL(
        this.esForm.get(['AuthorizedRep', 'signature']).value
      );
      // populate Auth Representative Sign date as Today with new or drafted form
      if (this.esForm.get('statusId').value === 2) {
        this.esForm
          .get(['AuthorizedRep', 'date'])
          .setValue(moment().format('MM/DD/YYYY'));
      } else {
        const signDate = this.esForm.get(['AuthorizedRep', 'date']).value;
        this.esForm
          .get(['AuthorizedRep', 'date'])
          .setValue(moment(new Date(signDate)).format('MM/DD/YYYY'));
        this.signaturePad.off();
      }
      switch (this.formData.statusId) {
        case 1: //Submitted
          // this.atOeBs = false;
          this.isReadOnly = !this.hasRole('ADMIN');
          this.isShowSaveAsDraft = false;
          break;
        case 2: //Draft
          this.isShowSaveAsDraft =
            (!this.isInternal && !this.isReadOnly) || this.hasRole('DEV');
          this.isShowLeaveDialog =
            (!this.isInternal && !this.isReadOnly) || this.hasRole('DEV');
          break;
        case 3: // Approved
          // this.atOeBs = false;
          this.isReadOnly = !this.hasRole('ADMIN');
          this.isShowLeaveDialog = this.hasRole('ADMIN');
          this.isShowAccDist = this.hasRole('ADMIN');
          this.isShowSaveButton = this.hasRole('ADMIN');
          this.isAwardedAmount = this.hasRole(
            'ADMIN|FOUNDATIONAPPROVER|FOUNDATIONREVIEWER'
          );
          this.isShowApproveBtn = this.hasRole('DEV');
          this.isAccDistEditable = this.hasRole('ADMIN');
          break;
        case 7: //Pending CR&CA Approval
          this.isReadOnly = !this.hasRole('ADMIN|FOUNDATIONAPPROVER');
          this.isShowLeaveDialog = this.hasRole('ADMIN|FOUNDATIONAPPROVER');
          this.isShowApproveBtn =
            this.hasRole('FOUNDATIONAPPROVER') &&
            this.permissionsService.getUserId() ===
              this.formData.FormLogInfo.empId
              || this.hasRole('DEV');;
          this.isShowWithdrawBtn = !this.isInternal;
          this.isShowSaveButton = this.hasRole('ADMIN');
          this.isTaxExemptEditable = this.hasRole('ADMIN');
          this.isAwardedAmount = this.hasRole(
            'ADMIN|FOUNDATIONAPPROVER|FOUNDATIONREVIEWER'
          );
          break;
        case 8: //Pending CCC Review
          this.isReadOnly = !this.hasRole('ADMIN|FOUNDATIONAPPROVER');
          this.isShowLeaveDialog = this.hasRole('ADMIN|FOUNDATIONAPPROVER');
          this.isShowApproveBtn =
            this.hasRole('FOUNDATIONAPPROVER') &&
            this.permissionsService.getUserId() ===
              this.formData.FormLogInfo.empId;
          this.isShowSaveButton = this.hasRole('ADMIN');
          this.isTaxExemptEditable = this.hasRole('ADMIN');
          this.isShowWithdrawBtn = !this.isInternal;
          this.isAwardedAmount = this.hasRole(
            'ADMIN|FOUNDATIONAPPROVER|FOUNDATIONREVIEWER'
          );
          break;
        case 9: //Pending Foundation Board of Directors Review
          this.isReadOnly = !this.hasRole('ADMIN|FOUNDATIONAPPROVER');
          this.isShowLeaveDialog = this.hasRole('ADMIN|FOUNDATIONAPPROVER');
          this.isShowApproveBtn = this.hasRole('FOUNDATIONAPPROVER');
          this.isShowAccDist = this.hasRole('ADMIN|FOUNDATIONAPPROVER');
          this.isShowSaveButton = this.hasRole('ADMIN');
          this.isTaxExemptEditable = this.hasRole('ADMIN');
          this.isAwardedAmount = this.hasRole(
            'ADMIN|FOUNDATIONAPPROVER|FOUNDATIONREVIEWER'
          );
          this.isAccDistEditable = this.hasRole('ADMIN|FOUNDATIONAPPROVER');
          this.isShowWithdrawBtn = !this.isInternal;
          break;
        case 10:
        case 11:
          this.isReadOnly = !this.hasRole('ADMIN');
          this.isShowLeaveDialog = this.hasRole('ADMIN');
          this.isShowAccDist = this.hasRole('ADMIN');
          this.isShowSaveButton = this.hasRole('ADMIN');
          this.isAwardedAmount = true;
          this.isAccDistEditable = this.hasRole('ADMIN');          
          this.isShowApproveBtn = this.hasRole('DEV');
          break;
        case 23: // pending CIT review
          this.isReadOnly = !this.hasRole('ADMIN|CITAPPROVER');
          this.isShowLeaveDialog = this.hasRole('ADMIN|CITAPPROVER');
          this.isAccDistEditable = this.hasRole('ADMIN|CITAPPROVER');
          this.isShowAccDist = this.hasRole('ADMIN|CITAPPROVER');
          this.isShowApproveBtn = this.hasRole('CITAPPROVER');
          this.isShowSaveButton = this.hasRole('ADMIN');
          this.isAwardedAmount = this.hasRole('ADMIN|CITAPPROVER|CITREVIEWER');
          this.isShowWithdrawBtn = !this.isInternal;
          this.isTaxExemptEditable = this.hasRole('ADMIN');
          this.isShowSaveAsDraft = false;
          break;
        default:
          this.isReadOnly = true;
          this.isShowLeaveDialog = false;
          this.isShowSaveAsDraft = false;
          this.isAwardedAmount = true;
          this.isAwardedAmountEditable = false;
          break;
      }
    });
  }

  // Unsubscribe from state data changes
  endSubscriptions(): void {
    this.pendingSubscription.unsubscribe();
    this.errorSubscription.unsubscribe();
    this.stateDataSubscription.unsubscribe();
    if (!this.isInternal) {
      this.profileDataSubscription.unsubscribe();
    }
  }

  ngOnDestroy() {
    this.endSubscriptions();
    this.store.dispatch(new EventSponsorshipAction.LoadInitialState());
  }
}
